import { Icon, NavButton, Text } from 'shell/components';

const NavButtonDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>NavButton</Text>
            <NavButton startIcon={<Icon kind={'home'} />}>Courses</NavButton>
            <NavButton active startIcon={<Icon kind={'task'} />}>
                Tasks
            </NavButton>
        </>
    );
};

export default NavButtonDemo;
